// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stawag-comparison-staging-gjuce .gc-multiple-choice-checkbox{flex-shrink:0;display:flex;cursor:pointer;color:#fff;font-size:75%;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
